import getMonth from 'date-fns/get_month';
import getYear from 'date-fns/get_year';
import get from 'lodash/get';
import { connect } from 'react-redux';
import rtlDetect from 'rtl-detect';

import { SectionCodeEnum } from '@nucleo/section';
import TicketShopWidget from './TicketShopWidget';

const mapStateToProps = (state, props) => {
  const isFeatureEnabled = (key, language) =>
    get(props, `translations[${language}]['${key}']`, 'false')
      .toLowerCase()
      .replace(/\s+/, '') === 'true';

  const configState = props.actions.config.getLocalState(state);
  const catalogState = props.actions.catalog.getLocalState(state);
  const resaleAvailabilityState = props.actions.resaleAvailability.getLocalState(state);
  const cartState = props.actions.cart.getLocalState(state);
  const productListState = props.actions.productList.getLocalState(state);
  const calendarState = props.actions.calendar.getLocalState(state);
  const filterState = props.actions.filter.getLocalState(state);
  const filterCalendarState = {
    ...filterState, // PTE TODO test code
    ...props.actions.filterCalendar.getLocalState(state),
  };
  const language = configState.language;
  const defaultLanguage = configState.defaultLanguage;
  const productListTabsConfigKey = 'config.gravity.tabs.configuration';
  const activateCalendarEnhancedFeatureKey = 'config.gravity.activateCalendarEnhancedFeature';
  const calendarArrFiltersConfig = 'config.gravity.calendar.arrFilters';
  const productTypeFilterEnableKey = 'config.webreporting.filterByProductType';
  const replaceProductNameByPerformanceKey = 'config.gravity.product.replaceProductNameByPerf';
  const activateCalendarEnhancedFeature =
    configState.activateCalendarEnhancedFeature ||
    isFeatureEnabled(activateCalendarEnhancedFeatureKey, language || defaultLanguage);
  const useMainTitleBackgroundColor = isFeatureEnabled(
    'gravity.TabList.useMainTitleBackgroundColor',
    language || defaultLanguage,
  );

  configState.isFilterProductTypeEnable = isFeatureEnabled(
    productTypeFilterEnableKey,
    language || defaultLanguage,
  );
  configState.withTourOnly = activateCalendarEnhancedFeature;

  const productListTabsConfig = JSON.parse(
    get(props, `translations[${defaultLanguage}]['${productListTabsConfigKey}']`, '{}').replace(
      /\\/g,
      '',
    ),
  );
  const streamOnlineState = props.actions.streamOnline.getLocalState(state);
  const replaceProductNameByPerformance = isFeatureEnabled(
    replaceProductNameByPerformanceKey,
    language || defaultLanguage,
  );

  return {
    hostname: configState.hostname,
    apiKey: configState.apiKey,
    defaultLanguage,
    isEmbedded: get(configState, 'configuration.isEmbedded', false),
    currencyCode: get(configState, 'configuration.currencyCode', 'CHF'),
    waitingListEnabled: get(configState, 'configuration.waitingListEnabled', false),
    catalog: catalogState,
    resaleAvailabilityState,
    cart: cartState,
    productList: productListState,
    filter: filterState,
    filterCalendar: filterCalendarState,
    calendar: calendarState,
    activateCalendarEnhancedFeature,
    productListTabsConfig,
    arrCalendarFilters: JSON.parse(
      get(props, `translations[${defaultLanguage}]['${calendarArrFiltersConfig}']`, '[]').replace(
        /\\/g,
        '',
      ),
    ),
    configError: configState.ERROR,
    configErrorCode: configState.ERROR_CODE,
    config: configState,
    useGoogleEnhancedTracking: get(configState, 'configuration.useGoogleEnhancedTracking', false),
    streamOnline: streamOnlineState,
    replaceProductNameByPerformance,
    useMainTitleBackgroundColor,
    useGA4: get(configState, 'configuration.useGA4', false),
  };
};

const mapDispatchToProps = (dispatch, props) => {
  // Use to get the month should display/load data when calendar show up
  function getInitialMonth(firstDate, lastDate) {
    const today = new Date();
    const firstCalendarDay = new Date(firstDate);
    const lastCalendarDay = new Date(lastDate);
    if (firstCalendarDay <= today && lastCalendarDay >= today) {
      return today;
    }
    return firstCalendarDay;
  }
  /**
   * Method to load the general configuration
   */
  function load() {
    dispatch(props.actions.catalog.load(this.config, { maxOccurrences: 50, maxOccurrenceDays: 3 }));
  }

  /**
   * Method to load the resale availability
   */
  function loadResaleAvailability() {
    dispatch(props.actions.resaleAvailability.load(this.config));
  }

  /**
   * Method to load the content of the cart
   */
  function loadCart() {
    dispatch(props.actions.cart.load(this.config));
  }

  /**
   * Method to change the language
   * Applied on all nucleos the change of language
   * modify the url to append or change the language to it
   * @param {string} language is represented by locale like 'en'
   */
  function changeLanguage(language) {
    dispatch(props.actions.config.changeLanguage(language));
    /**
     * Modify the url to append the language
     */
    const queryString = window.parent.location.search;
    const hash = window.parent.location.hash;
    const auxURL = window.parent.location.href.replace(hash, '');
    let url;
    if (queryString === '' || queryString === '?') {
      url = `${auxURL}?lang=${language}${hash}`;
    } else {
      url = auxURL.replace(/lang=[^\\&]+(\\&)?/i, `lang=${language}`) + hash;
    }
    history.pushState({}, '', url);
    /**
     * Modify the cookie
     */
    document.cookie = `lang=${language}; path=/`;
    /**
     * adapt text direction on of the language
     */
    document.dir = rtlDetect.getLangDir(language);
  }

  /**
   * The function called on filter is applied
   *
   */
  function onFilterCalendarApplied({ month, detailDay, filterCriteria }) {
    dispatch(props.actions.filterCalendar.apply({ filterCriteria }));
    //
    dispatch(
      props.actions.calendar.loadMonth(this.config, getYear(month), getMonth(month), {
        filterCriteria,
      }),
    );
  }
  /**
   * The function called on filter is reset
   */
  function onFilterCalendarReset({ month, detailDay }) {
    dispatch(props.actions.filterCalendar.reset());
    dispatch(
      props.actions.calendar.loadMonth(this.config, getYear(month), getMonth(month), {
        filterCriteria: {},
      }),
    );
  }

  /**
   * The function called on filter is applied
   *
   */
  function onFilterApplied(filterCriteria) {
    dispatch(props.actions.filter.apply(filterCriteria));
    dispatch(props.actions.productList.filterChanged(filterCriteria));
  }
  /**
   * The function called on filter is reset
   */
  function onFilterReset(tabCode) {
    dispatch(props.actions.filter.reset(tabCode));
    dispatch(props.actions.productList.filterChanged({}));
  }

  /**
   * Called when a product is selected
   * Not pass isSelectAll / pass undefined if select for single product
   * Pass isSelectAll true/false if select all option is selected/deselected
   */
  function onProductSelectChange(tabCode, sectionCode, productId, isSelectAll) {
    dispatch(
      props.actions.productList.productSelectChanged(tabCode, sectionCode, productId, isSelectAll),
    );
  }

  /**
   * The function handle dispatch action to nucleo product to fetch the list new product with filtered criteria
   *
   * @param {*} offset: current offet
   * @param {*} limit: limitattion per fetching
   * @param {*} tabCode: tab code
   * @param {*} sectionCode: section code
   * @param {*} isReportContext: show that in report context or not
   */
  function onLoadMore(
    offset,
    limit,
    tabCode,
    sectionCode,
    filterCriteria,
    isFilterChanged,
    customSectionDisplay,
    isReportContext,
  ) {
    const sectionCriteria = {};
    switch (tabCode) {
      case 'EVENTS':
        if (sectionCode === SectionCodeEnum.ALL_EVENTS) {
          // To fetch all products that not have topic => -1
          // STX-90776: In report context, no need to group product by sub topics, all product display in same section
          // STX-90776: => Fetch all products that result not have sub topics info => null
          sectionCriteria.subTopicId = isReportContext ? null : -1;
        } else {
          sectionCriteria.subTopicId = sectionCode;
        }
        sectionCriteria.family = 'EVENT';
        break;
      case 'OFFERS':
        sectionCriteria.advantageType = sectionCode;
        break;
      case 'HOSPITALITY':
        sectionCriteria.family = 'HOSPITALITY';
        break;
      case 'HOSPITALITY_BUNDLE':
        sectionCriteria.family = 'HOSPITALITY_BUNDLE';
        break;
      case 'TOURS': // Currently, we haven't had any section criteria for tours yet.
        break;
      default:
        sectionCriteria.productType = sectionCode;
        break;
    }

    dispatch(
      props.actions.productList.loadProducts(
        this.config,
        tabCode,
        sectionCode,
        offset,
        limit,
        sectionCriteria,
        filterCriteria,
        isFilterChanged,
        customSectionDisplay,
      ),
    );
  }

  function onLoadTabs(tabDatas) {
    dispatch(props.actions.productList.loadTabs(this.config, tabDatas)).then(response => {
      // Load required data for fitler fields depend on available tabs and catalogSummary
      dispatch(props.actions.filter.initFilterData(tabDatas, response, this.config));
    });
  }

  function onTabChange(tab) {
    dispatch(props.actions.productList.changeTab(this.config, tab));
  }

  function loadMonth(year, month) {
    dispatch(props.actions.calendar.loadMonth(this.config, year, month, this.filterCalendar));
  }

  function loadDay(year, month, day) {
    dispatch(props.actions.calendar.loadDay(this.config, year, month, day, this.filterCalendar));
  }

  function monthChange(monthDate) {
    return loadMonth(getYear(monthDate), getMonth(monthDate));
  }

  async function loadMonths() {
    const months = await dispatch(
      props.actions.calendar.loadMonths(this.config, undefined, this.filterCalendar),
    );
    const initDate =
      months &&
      months.calendarRange &&
      getInitialMonth(months.calendarRange[0], months.calendarRange[1]);
    // use the first month where there are data as default value
    if (initDate) {
      loadMonth.bind(this)(getYear(initDate), getMonth(initDate));
    }
  }

  function logError(errorCode, error, info) {
    dispatch(props.actions.config.logError(errorCode, error, info));
  }

  async function onWatchStreamOnline(data, actionUrl, shouldRedirectToLogin) {
    if (shouldRedirectToLogin) {
      window.location.href = `${this.config.config.baseUrl}account/login`;
      return;
    }
    const response = await dispatch(
      props.actions.streamOnline.createStreamOnlineOrder(this.config, data, actionUrl),
    );
    if (!response || this.streamOnline.ERROR) {
      return;
    }
    const streamContent = await response.streamContentValue;
    if (streamContent) {
      const link = streamContent.link;
      if (link.toLowerCase().includes('<iframe')) {
        dispatch(props.actions.streamOnline.updateDialogVisibility(true));
      } else {
        window.open(link);
      }
    }
  }

  function updateStreamOnlineDialogVisibility(isVisible) {
    dispatch(props.actions.streamOnline.updateDialogVisibility(isVisible));
  }

  return {
    load,
    loadResaleAvailability,
    loadCart,
    changeLanguage,
    onTabChange,
    onLoadTabs,
    onLoadMore,
    onFilterCalendarApplied,
    onFilterCalendarReset,
    onFilterApplied,
    onFilterReset,
    loadMonths,
    loadMonth,
    loadDay,
    monthChange,
    logError,
    getInitialMonth,
    onProductSelectChange,
    onWatchStreamOnline,
    updateStreamOnlineDialogVisibility,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
)(TicketShopWidget);
